module.exports = __webpack_public_path__ + "static/kalpanchart-mob-1abd271a9fd96cac23592ffd2aeed4a0.png";